import { BRAND } from './brand';

export const APP_CONFIG = {
  name: BRAND.name,
  tagline: BRAND.tagline,
  /**
   * Injected from package.json at build time by `vite.config.ts`. The literal
   * is only a development fallback — package.json is the source of truth, so
   * the number in Settings can never drift from the released tag.
   */
  version: import.meta.env.VITE_APP_VERSION ?? '0.0.0-dev',
  schemaVersion: 1,
  /** Quotes are valid for this many days by default. */
  quoteValidityDays: 30,
  /** Maximum accepted logo upload, in bytes. */
  maxLogoBytes: 512 * 1024,
  /**
   * `@react-pdf/renderer` can embed PNG and JPEG only. Accepting an SVG or
   * WebP here would upload cleanly, preview fine in the browser, and then
   * silently fail on the one artefact that matters — the PDF.
   */
  logoMimeTypes: ['image/png', 'image/jpeg'] as const,
  storageNamespace: BRAND.storageNamespace,
  storageVersion: 'v1',
  links: {
    upgrade: '#pricing',
  },
} as const;

export type AppConfig = typeof APP_CONFIG;
